import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../../../Base/Components/BaseModal/BaseModal';
import ManagerAddWorkerByRegistration from './ManagerAddWorkerByRegistration';
import { Size } from '../../../../../../Enums/Size.enum';
import ManagerAddWorkerByInvitation from './ManagerAddWorkerByInvitation';

interface Props extends BaseModalProps {
	onCreate: () => void;
}

const ManagerAddWorkerByInvitationModal: React.FC<Props> = props => {
	return (
		<BaseModal
			{...props}
			title='component.workplaceAndWorkers.inviteWorker'
			size={Size.LG}>
			<ManagerAddWorkerByInvitation onCreate={props.onCreate} />
		</BaseModal>
	);
};

export default ManagerAddWorkerByInvitationModal;
